// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__h7ArP","messages_header":"Messages_messages_header__qUHnw","close":"Messages_close__2951f","refresh":"Messages_refresh__3W32h"};